const fn_getAllKeys = (data) => {
  return (
    data?.flatMap((record) => [
      record.key,
      ...(record.children ? fn_getAllKeys(record.children) : []),
    ]) || []
  );
};
const fn_LoadChildren = ({ allRutas = [], patternId }) => {
  let opts = [];
  const childrens = allRutas?.filter((x) => x.rutapadre === patternId);
  childrens.forEach((row) => {
    let objRuta = {
      title: row?.nombre,
      key: row?.id,
      isLeaf: row?.eslink,
      data: row,
    };
    const childs = allRutas?.filter((x) => x.rutapadre === row?.id);
    if (childs.length > 0) {
      let objRutaChild = fn_LoadChildren({ allRutas, patternId: row?.id });
      objRuta = { ...objRuta, children: objRutaChild };
    }
    opts = [...opts, objRuta];
  });
  return opts;
};

export { fn_LoadChildren, fn_getAllKeys };
